import * as React from 'react';
import { getAgendaMeetingActivities } from '../../../api/activityClientApi';
import { DashboardCard } from './DashboardCard';
import { appUrlBuilder } from '../../../utils/appUrlBuilder';
import { DashboardCardContent } from './DashboardCardContent';

export function DashboardAnnualMeetingCard(): JSX.Element {
    
    const [meetings, setMeetings] = React.useState([]);
    const [status, setStatus] = React.useState("")
    
    React.useEffect(()=>{
            const getData = async () => {
            const activities = await getAgendaMeetingActivities("AnnualWorkgroupStatus");
            const now = new Date();
            
            const activitiesPresent = activities
                .filter(a => new Date(a.start) <= now && new Date(a.end) >= now)
                .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
            
            const futureActivities = activities
                .filter(a => a.start && new Date(a.start) > now)
                .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());

            if(activitiesPresent.length > 0){
                setStatus("present");
                setMeetings(activitiesPresent);
            } else {
                setStatus("future");
                setMeetings(futureActivities);
            }
        };
        getData();
    },[])

    return (
        <DashboardCard backgroundIcon="interface_glyph_comment" backgroundColor="white">
            {meetings.length > 0 ? (
                <DashboardCardContent 
                    title="Årlige drøftelse"
                    activityStatus={status === "present" ? `Nuværende årlige drøftelser ${meetings[0].start.toLocaleDateString()} - ${meetings[0].end.toLocaleDateString()}` : `Kommende årlige drøftelser ${meetings[0].start.toLocaleDateString()} - ${meetings[0].end.toLocaleDateString()}`}
                    activityLink={appUrlBuilder.annualWorkGroupStatus.internal(meetings[0].id)}
                    activityTitle={meetings[0].title}
                    
                />
            ) : (
                <DashboardCardContent 
                    title="Årlige drøftelse"
                    activityStatus="Ingen kommende årlige drøftelser"
                    activityLink={appUrlBuilder.annualWorkGroupStatus.list()}
                    activityTitle="Opret en årlig drøftelse"
                    createNew={true}
                />
            )}
    </DashboardCard>
    );
}